{
  "brand": "Baby Plan",
  "nav": { "label": "Main", "plan": "Plan", "today": "Today", "track": "Track", "sounds": "Sounds", "learn": "Learn", "chat": "Chat", "log": "Log a sleep, feed or diaper" },
  "header": { "openSettings": "{{name}}: profile and settings", "openBaby": "{{name}}: baby details", "profile": "Profile and settings" },
  "actions": { "back": "Back", "done": "Done", "save": "Save", "cancel": "Cancel", "undo": "Undo", "retry": "Try again", "continue": "Continue", "close": "Close" },
  "errors": {
    "offline": "You're offline. Changes are saved on this phone and sync when you're back online.",
    "generic": "Something went wrong. Please try again.",
    "feature_required": "This is part of Baby Plan Premium.",
    "consent_required": "Please allow Baby Plan to store your baby's health data first."
  },
  "comingSoon": "This screen is being built.",
  "notFound": { "title": "Page not found", "lead": "This link is old or has a typo. Everything you logged is safe.", "home": "Go to Today", "help": "Open the help center" }
}
